import { FunctionComponent, h, Fragment } from 'preact';
import { ButtonProps } from '@components/atoms/button/button';
import { FeedbackButtonContainer, StyledButton } from './feedback-button.styles';
import { useScreen } from '@hooks/useScreen';
import Icon from '@components/atoms/icon/icon';
import { useBrandSettings } from '@hooks/useBrandSettings';

export interface FeedbackButtonProps extends ButtonProps {
  isOpen: boolean;
}

const FeedbackButton: FunctionComponent<FeedbackButtonProps> = ({ isOpen, ...props }) => {
  const { buttonCopy } = useBrandSettings();
  const { isTablet } = useScreen();

  const defaultContent = (
    <p>
      Give Your <br /> Feedback
    </p>
  );

  return (
    <StyledButton {...props} $isMobile={isTablet} open={isOpen}>
      <FeedbackButtonContainer open={isOpen}>
        {isOpen && (
          <div style={{ height: '24px' }}>
            <Icon name="close" />
          </div>
        )}
        {!isOpen && (
          <Fragment>
            <div style={{ height: '20px' }}>
              <Icon name="thumbsUpDown" />
            </div>
            {!isTablet && (buttonCopy || defaultContent)}
          </Fragment>
        )}
      </FeedbackButtonContainer>
    </StyledButton>
  );
};

export default FeedbackButton;
